import './campanas.css';

const VERDE = '#25D366';
const VERDE_OSCURO = '#128C7E';

export const E = {
  tarjeta: { border: '1px solid #e5e7eb', borderRadius: 8, padding: 16, marginBottom: 12, background: '#fff' },
  campo: { display: 'flex', flexDirection: 'column', gap: 4, marginBottom: 12 },
  etiqueta: { fontSize: 13, fontWeight: 600, color: '#374151' },
  input: { padding: '8px 10px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 14 },
  fila2: { display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap' },
  btnPrimary: { background: VERDE, color: '#fff', border: 'none', borderRadius: 6, padding: '8px 14px', fontWeight: 600, cursor: 'pointer' },
  btnGhost: { background: 'transparent', color: VERDE_OSCURO, border: `1px solid ${VERDE_OSCURO}`, borderRadius: 6, padding: '8px 14px', fontWeight: 600, cursor: 'pointer' },
};

// Formulario de nueva campaña, con el mismo aspecto que el creador de plantillas.
const WA_GREEN = '#128C7E';
const WA_GREEN_DARK = '#075E54';

export const F = {
  layout: { display: 'flex', gap: 20, flexWrap: 'wrap', alignItems: 'flex-start' },
  col: { flex: '1 1 420px', minWidth: 300, background: '#fff', borderRadius: 12, padding: 20, boxShadow: '0 1px 3px rgba(0,0,0,0.08)' },
  previewCol: { flex: '0 0 320px', display: 'flex', flexDirection: 'column', gap: 10, position: 'sticky', top: 0 },
  title: { margin: '0 0 4px', fontSize: 16, fontWeight: 700, color: '#111827' },
  subtitle: { margin: '0 0 18px', fontSize: 13, color: '#6b7280' },
  paso: { borderTop: '1px solid #f3f4f6', paddingTop: 16, marginTop: 4, marginBottom: 6 },
  pasoCabecera: { display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 },
  pasoNumero: (hecho) => ({
    width: 24, height: 24, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: 12, fontWeight: 700, flexShrink: 0,
    background: hecho ? WA_GREEN : '#e5e7eb', color: hecho ? '#fff' : '#374151',
  }),
  pasoTitulo: { margin: 0, fontSize: 14, fontWeight: 700, color: '#111827' },
  field: { display: 'flex', flexDirection: 'column', gap: 5, marginBottom: 14 },
  row: { display: 'flex', gap: 10, alignItems: 'flex-start', flexWrap: 'wrap' },
  label: { fontSize: 13, fontWeight: 600, color: '#374151' },
  input: { border: '1px solid #d1d5db', borderRadius: 8, padding: '9px 11px', fontSize: 14, outline: 'none', width: '100%', boxSizing: 'border-box', fontFamily: 'inherit', background: '#fff' },
  hint: { fontSize: 12, color: '#9ca3af' },
  zonaFichero: (activa) => ({
    display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4, padding: '18px 14px', borderRadius: 8,
    border: `1.5px dashed ${WA_GREEN}`, background: activa ? '#e7f5f2' : '#fff', color: WA_GREEN_DARK,
    cursor: 'pointer', textAlign: 'center', fontSize: 14, fontWeight: 600,
  }),
  zonaFicheroNombre: { fontSize: 13, fontWeight: 500, color: '#374151' },
  oculto: { position: 'absolute', width: 1, height: 1, opacity: 0, overflow: 'hidden', pointerEvents: 'none' },
  segmentos: { display: 'inline-flex', background: '#f3f4f6', borderRadius: 8, padding: 3, gap: 3, marginBottom: 14 },
  segmento: (activo) => ({
    position: 'relative', padding: '7px 16px', borderRadius: 6, fontSize: 14, fontWeight: 600, cursor: 'pointer',
    background: activo ? '#fff' : 'transparent', color: activo ? WA_GREEN_DARK : '#6b7280',
    boxShadow: activo ? '0 1px 2px rgba(0,0,0,0.1)' : 'none',
  }),
  actions: { display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 8, borderTop: '1px solid #f3f4f6', paddingTop: 16 },
  btnPrimary: { background: WA_GREEN, color: '#fff', border: 'none', borderRadius: 8, padding: '9px 16px', fontSize: 14, fontWeight: 600, cursor: 'pointer' },
  btnGhost: { background: '#fff', color: '#374151', border: '1px solid #d1d5db', borderRadius: 8, padding: '9px 16px', fontSize: 14, fontWeight: 600, cursor: 'pointer' },
  btnSmall: { background: '#e7f5f2', color: WA_GREEN_DARK, border: 'none', borderRadius: 6, padding: '6px 12px', fontSize: 13, fontWeight: 600, cursor: 'pointer' },
  deshabilitado: { opacity: 0.55, cursor: 'not-allowed' },
  banner: (tipo) => {
    const paleta = {
      error: { bg: '#fee2e2', fg: '#991b1b', bd: '#fca5a5' },
      aviso: { bg: '#fef3c7', fg: '#92400e', bd: '#fcd34d' },
      info: { bg: '#dbeafe', fg: '#1e40af', bd: '#93c5fd' },
    };
    const p = paleta[tipo] || paleta.info;
    return { padding: '9px 12px', borderRadius: 8, fontSize: 13, marginBottom: 8, background: p.bg, color: p.fg, border: `1px solid ${p.bd}` };
  },
  informe: { background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 8, padding: 12, marginBottom: 14 },
  cifras: { display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 8 },
  cifra: { background: '#fff', border: '1px solid #e5e7eb', borderRadius: 999, padding: '4px 10px', fontSize: 12, fontWeight: 600, color: '#374151' },
  informeLinea: { margin: '4px 0', fontSize: 13, color: '#4b5563' },
  previewTitle: { fontSize: 12, fontWeight: 700, color: '#6b7280', textTransform: 'uppercase', letterSpacing: 0.5, textAlign: 'center' },
  phone: { width: '100%', boxSizing: 'border-box', background: '#e5ddd5', borderRadius: 14, padding: 14, boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.05)' },
  bubble: { background: '#fff', borderRadius: 8, padding: '8px 10px 6px', boxShadow: '0 1px 1px rgba(0,0,0,0.15)', maxWidth: '85%' },
  bubbleHeader: { fontWeight: 700, fontSize: 14, color: '#111827', marginBottom: 4 },
  previaMedia: {
    background: '#e5e7eb', borderRadius: 6, minHeight: 72, marginBottom: 4, overflow: 'hidden',
    display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#374151', fontSize: 13, fontWeight: 600,
  },
  previaMediaImg: { width: '100%', maxHeight: 140, objectFit: 'cover', display: 'block' },
  bubbleBody: { fontSize: 14, color: '#111827', whiteSpace: 'pre-wrap', lineHeight: 1.4 },
  bubbleFooter: { fontSize: 12, color: '#8696a0', marginTop: 5 },
  bubbleTime: { fontSize: 10, color: '#8696a0', textAlign: 'right', marginTop: 2 },
  bubbleButtons: { display: 'flex', flexDirection: 'column', gap: 4, marginTop: 6, maxWidth: '85%' },
  previewButton: { background: '#fff', color: '#00a5f4', borderRadius: 8, padding: 9, textAlign: 'center', fontSize: 14, fontWeight: 500, boxShadow: '0 1px 1px rgba(0,0,0,0.1)' },
  previewVacio: { fontSize: 13, color: '#54656f', textAlign: 'center', padding: '24px 8px' },
  varTag: { background: '#eef2ff', color: '#4338ca', borderRadius: 4, padding: '0 4px', fontWeight: 700, fontFamily: 'monospace', fontSize: 13 },
  ejemplo: { fontSize: 12, color: '#6b7280', textAlign: 'center' },
  resumen: { background: '#fff', borderRadius: 12, padding: 14, boxShadow: '0 1px 3px rgba(0,0,0,0.08)', fontSize: 13 },
  resumenFila: { display: 'flex', justifyContent: 'space-between', gap: 10, padding: '5px 0', borderBottom: '1px solid #f3f4f6' },
  resumenClave: { color: '#6b7280' },
  resumenValor: { color: '#111827', fontWeight: 600, textAlign: 'right' },
};

const PALETA_ESTADOS = {
  PROGRAMADA: { bg: '#dbeafe', fg: '#1e40af' },
  ENVIANDO: { bg: '#fef3c7', fg: '#92400e' },
  COMPLETADA: { bg: '#dcfce7', fg: '#166534' },
  CANCELADA: { bg: '#f3f4f6', fg: '#4b5563' },
  FALLIDA: { bg: '#fee2e2', fg: '#991b1b' },
  PENDIENTE: { bg: '#f3f4f6', fg: '#4b5563' },
  ENVIADO: { bg: '#dcfce7', fg: '#166534' },
  FALLIDO: { bg: '#fee2e2', fg: '#991b1b' },
  DESCONOCIDO: { bg: '#ede9fe', fg: '#5b21b6' },
};

// Listado y detalle de campañas. El texto lleva color propio: el panel que
// las contiene hereda un color claro.
export const L = {
  tarjeta: { background: '#fff', borderRadius: 12, padding: 20, boxShadow: '0 1px 3px rgba(0,0,0,0.08)', marginBottom: 16, color: '#111827' },
  cabecera: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap', marginBottom: 16 },
  titulo: { margin: 0, fontSize: 16, fontWeight: 700, color: '#111827' },
  subtitulo: { margin: '2px 0 0', fontSize: 13, color: '#6b7280' },
  acciones: { display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' },
  tabla: { width: '100%', borderCollapse: 'collapse', fontSize: 14 },
  th: { textAlign: 'left', padding: '10px 12px', fontSize: 12, fontWeight: 700, color: '#6b7280', textTransform: 'uppercase', letterSpacing: 0.4, borderBottom: '1px solid #e5e7eb' },
  td: { padding: '12px', borderBottom: '1px solid #f3f4f6', verticalAlign: 'middle', color: '#111827' },
  tdSuave: { padding: '12px', borderBottom: '1px solid #f3f4f6', verticalAlign: 'middle', color: '#4b5563', fontSize: 13 },
  fila: { cursor: 'pointer' },
  nombre: { fontWeight: 600, color: '#111827' },
  plantilla: { fontFamily: 'monospace', fontSize: 12, background: '#f3f4f6', color: '#374151', borderRadius: 4, padding: '2px 6px', whiteSpace: 'nowrap' },
  estado: (estado) => {
    const p = PALETA_ESTADOS[estado] || PALETA_ESTADOS.CANCELADA;
    return { display: 'inline-block', padding: '3px 10px', borderRadius: 999, fontSize: 12, fontWeight: 700, background: p.bg, color: p.fg, whiteSpace: 'nowrap' };
  },
  vacio: { padding: '32px 16px', textAlign: 'center', color: '#6b7280', fontSize: 14 },
  paginacion: { display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 12 },
  progreso: { minWidth: 220 },
  barraFila: { display: 'flex', alignItems: 'center', gap: 8 },
  barra: { flex: 1, height: 8, background: '#e5e7eb', borderRadius: 4, overflow: 'hidden' },
  relleno: (porcentaje) => ({ width: `${porcentaje}%`, height: '100%', background: WA_GREEN, borderRadius: 4 }),
  porcentaje: { fontSize: 12, fontWeight: 700, color: '#374151', minWidth: 36, textAlign: 'right' },
  contadores: { display: 'block', marginTop: 4, fontSize: 12, color: '#6b7280' },
  cifras: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(110px, 1fr))', gap: 10, margin: '16px 0 4px' },
  cifra: { background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 10, padding: '10px 12px' },
  cifraValor: { fontSize: 20, fontWeight: 700, color: '#111827' },
  cifraEtiqueta: { fontSize: 12, color: '#6b7280' },
  meta: { margin: '6px 0 0', fontSize: 13, color: '#4b5563' },
  filtro: { display: 'flex', alignItems: 'center', gap: 8 },
  filtroEtiqueta: { fontSize: 13, fontWeight: 600, color: '#374151' },
  select: { border: '1px solid #d1d5db', borderRadius: 8, padding: '7px 10px', fontSize: 14, background: '#fff', color: '#111827' },
  confirmacion: { fontSize: 13, fontWeight: 600, color: '#991b1b' },
  btnPeligro: { background: '#dc2626', color: '#fff', border: 'none', borderRadius: 8, padding: '9px 16px', fontSize: 14, fontWeight: 600, cursor: 'pointer' },
};
